import { CreateRankingTypeDTO, EditRankingTypeDTO, RankingTypeDTO } from './ranking-type-profile.dto';
import { RootState } from '../../../../store/reducers';

export const selectCurrentRankingType = (
  state: RootState,
): CreateRankingTypeDTO | EditRankingTypeDTO | RankingTypeDTO => state.rankings.currentType;
